import React, { useContext } from "react";
import { Button } from "reactstrap";
import { useHistory } from "react-router-dom";
import { useIntl } from "react-intl";

import EventContext from "../contexts/event";
import UserContext from "../contexts/user";
import { Presentation } from "../types/presentation";

const SideBarBtns = ({
  presentation,
  setShowForumSidebar,
  forumIsOpen = false,
  forum = false,
}: {
  presentation: Presentation;
  setShowForumSidebar?: (arg0: any) => void;
  forum?: boolean;
  forumIsOpen?: boolean;
}) => {
  const eventContext = useContext(EventContext);
  const userContext = useContext(UserContext);
  const history = useHistory();
  const intl = useIntl();

   console.log("SideBar Loading",forum,forumIsOpen,presentation)

  return (
    
    <div
      className={`
            side-trans-btns
            ${forum ? "forum-side-trans-btns" : ""}

            ${forumIsOpen ? "forum-open-side-trans-btns" : ""}
        `}
    >
      {/*{ forumIsOpen ? (*/}
      {/*  <Button*/}
      {/*    disabled={!eventContext.forum}*/}
      {/*    onClick={() => {*/}
      {/*      if (forum) {*/}
      {/*        setShowForumSidebar && setShowForumSidebar((s: any) => !s);*/}
      {/*      }*/}
      {/*    }}*/}
      {/*    className="forum-btn"*/}
      {/*    color="primary"*/}
      {/*  >*/}
      {/*    /!* Forum  *!/*/}
      {/*    <img className="forum-arrow" src="/icons/filter-arrow.svg" alt="" />*/}
      {/*  </Button>*/}
      {/*) : (*/}
      {/*  ""*/}
      {/*)}*/}
      {/* {eventContext.presentationsWithQuestions.indexOf(presentation._id) >
        -1 && (
        <Button
          disabled={!eventContext.quiz}
          color="primary"
          className="quiz-btn"
          style={{width:80}}
          onClick={() => {
            userContext.user
              ? history.push(
                  `/${eventContext.slug}/${presentation._id}/quiz${document.location.search}`
                )
              : userContext.setShowLogin(true);
          }}
        >
          Quiz
          <img src="/icons/quiz-ico.svg" alt="quiz" />
        </Button>
      )} */}
      {/* {eventContext.presentationsWithResults.indexOf(presentation._id) > -1 && (
        <Button
          color="primary"
          className="quiz-res-btn"
          style={ intl.locale === 'fr' ? {width:160} :  {width:125} }
          onClick={() => {
            userContext.user
              ? history.push(
                  `/${eventContext.slug}/${presentation._id}/quiz-results${document.location.search}`
                )
              : userContext.setShowLogin(true);
          }}
        >
          {intl.formatMessage({ id: "quiz.results" })}
        </Button>
      )} */}

      {/* {
                // TODO: WIP
                eventContext.quiz &&
                (
                    userContext.user?.is_moderator ||
                    [presentation.speaker_id, presentation.association_id]
                        .map(i => i)
                        .includes(userContext.user?.external_id || "")
                ) && 
                <Button color="primary" className="quiz-mod-btn" onClick={() => { history.push(`/${eventContext.slug}/${presentation._id}/quiz-moderator${document.location.search}`) }}>{intl.formatMessage({id: 'quiz.management'})}</Button>
            } */}
    </div>
  );
};

export default SideBarBtns;
